import React, {
    useEffect,
    useState,
    useRef,
    useMemo,
    useLayoutEffect,
    useImperativeHandle,
    forwardRef,
} from 'react';
import { useMemoizedFn } from 'ahooks';
import PropsTypes from 'prop-types';
import {
    EndPosition,
    MarkIcon,
    SelectedIcon,
    StartPosition,
    ToolTip,
    ToolTipName,
} from './SvgModel';
import {
    INITIAL_VALUE,
    POSITION_NONE,
    ReactSVGPanZoom,
    TOOL_AUTO,
    TOOL_NONE,
} from 'react-svg-pan-zoom'; // 组件api见：https://github.com/chrvadala/react-svg-pan-zoom
// 组件api见：https://github.com/chrvadala/react-svg-pan-zoom
import _ from 'lodash';
import {
    ZOOM_FACTOR,
    DEFAULT_WIDTH,
    DEFAULT_HEIGHT,
    DEFAULT_BACKGROUND,
    DEFAULT_SVGBACKGROUND,
    COLOR_DEFAULT,
    COLOR_SELECTED,
    PATH_STYLE,
    HAVE_TOUCH_EVENT,
    findAndCombineDifferences,
    parseColorWithAlpha, PATH_STYLE_EX, clampPanTranslation,
} from './utils';
import { customGet, compare } from './utils';
import SvgTextEllipsis from './SvgTextEllipsis';

const path2LineKey = { start: 'line2Start', end: 'line2End', mid: 'line2Mid' };
// noRender 加入这个参数，表示只在可见区域内显示工位，其他区域不显示
// 处理移动端的缩放
// 移动端采用antd的高清方案：https://github.com/ant-design/ant-design-mobile/wiki/antd-mobile-0.8-%E4%BB%A5%E4%B8%8A%E7%89%88%E6%9C%AC%E3%80%8C%E9%AB%98%E6%B8%85%E3%80%8D%E6%96%B9%E6%A1%88%E8%AE%BE%E7%BD%AE
// 高清方案会根据系统进行viewport的设置，但会影响SVG的大小，这里获得dpr在componentDidMount是信息放大。
let dpr = 1;

// 文本测量缓存，避免频繁DOM操作
const textMeasurementCache = new Map();
if (window.flex) {
    const ua = navigator.userAgent;
    const matches = ua.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i);
    const UCVersion = ua.match(/U3\/((\d+|\.){5,})/i);
    const isUCHd = UCVersion && parseInt(UCVersion[1].split('.').join(''), 10) >= 80;
    const isIos = navigator.appVersion.match(/(iphone|ipad|ipod)/gi);
    if (!isIos && !(matches && matches[1] > 534) && !isUCHd) {
        dpr = 1;
    } else {
        dpr = window.devicePixelRatio;
    }
}

const WaferMap = forwardRef((props, ref) => {
    const {
        // 基本配置
        mapId,
        token,
        signatureKey,
        restfulSignature,
        mapKey,
        requestPrefix,
        defaultPath,
        mapDataSource,
        lang,
        key,
        isDoubleMap,

        // 回调函数
        onElementsLoad,
        reloadMap,
        setSelectedEleFinish,
        deleteFinish,
        onClick,
        onSelect,
        reloadFinish,
        handleGetPathInfo,

        // 显示与样式
        showPath,
        appGetPathByUrl,
        componentWidth,
        componentHeight,
        background,
        SVGBackground,
        style,
        SVGStyle,
        pathStartSvg,
        pathEndSvg,
        pathStyle,
        pathExStyle,
        markSvg,
        selectedSvg,
        textColor,
        elementsColor,
        isShowSvgDefaultColor,
        centerElement,
        centerEleRate,
        clickToCenter,
        guideFirstSvg,
        guideSecondSvg,
        guideThirdSvg,
        guideFirstSvgEx,
        refreshGuide,

        // 地图交互设置
        mapZoom,
        mapMove,
        touchable,
        isTouchDevice,
        windowsTouchSupport,
        zoomRate,
        scaleFactorMin,
        scaleFactorMax,
        selectMode,
        setSelectMode,
        selectableType,
        visibleElement,
        visibleType,
        visibleState,
        hideNameType,
        noName,
        showStateIds,
        markStateId,
        markStateSvg,
        multiple,
        isGenders,

        // 元素控制
        mapElementsList,
        markId,
        pathLineKey,
        elementRenderHandle,
        elementRenderTextAfterHandle,
        isTextToolTip,
        clickableElement,
        clickableType,
        clickableState,
        legendList,
        legendRender,
        AppendSvg,
        mapExtraProps,
        mapSpaceJump,
        reSetMapId,
        selectedEle,
        deleteId,
        getSvgDom,
        selectedIds,
        isShowArea,
        isNotAllowedEle,
        pathLevelUp,

        // 工具提示
        tooltipContent,
        defaultTooltipKey,
        textToolTipList,
        textToolTipRender,

        // 错误处理
        onClickError,
        customBaseMap,
        panBoundary
    } = props;

    // 拆分状态管理，减少不必要的重渲染
    const [tool, setTool] = useState(TOOL_AUTO);
    const [svgValue, setSvgValue] = useState(INITIAL_VALUE);
    const [zoom, setZoom] = useState(1);
    const [showTip, setShowTip] = useState(false);
    const [tipObj, setTipObj] = useState({});
    const [selectedEleState, setSelectedEleState] = useState([]);
    const [start, setStart] = useState(null);
    const [end, setEnd] = useState(null);
    const [path, setPath] = useState('');
    const [start2, setStart2] = useState(null);
    const [end2, setEnd2] = useState(null);
    const [path2, setPath2] = useState('');
    const [baseMap, setBaseMap] = useState({
        baseMapElement: null,
        baseMapUrl: '',
        width: 0,
        height: 0,
        areaAge: '',
    });
    const [mapElementState, setMapElementState] = useState([]);
    const [allElements, setAllElements] = useState([]);
    const [selectedCenterState, setSelectedCenterState] = useState({ x: null, y: null });
    const [selectedAreaState, setSelectedAreaState] = useState({ x: 0, y: 0, dragWidth: 0, dragHeight: 0 });
    const [locationSvgMark, setLocationSvgMark] = useState({});
    const [mapColorSet, setMapColorSet] = useState({});
    const [rateZoom, setRateZoom] = useState(null);
    const [mapIdState, setMapIdState] = useState(null);
    const [mergedScaleFactor, setMergedScaleFactor] = useState({
        scaleFactorMax: undefined,
        scaleFactorMin: undefined,
    })

    const [isClick, setIsClick] = useState(false);

    const [initialScaleFactor, setInitialScaleFactor] = useState(true);

    // 合并 scaleFactorMax/scaleFactorMin，优先级：props > colors 中的值
    useEffect(() => {
        let scaleFactorMaxTemp = scaleFactorMax !== undefined ? scaleFactorMax : mapColorSet?.scaleFactorMax ? Number(mapColorSet?.scaleFactorMax) : undefined;
        let scaleFactorMinTemp = scaleFactorMin !== undefined ? scaleFactorMin : mapColorSet?.scaleFactorMin ? Number(mapColorSet?.scaleFactorMin) : undefined;

     //   window.console.log('svgZoomValue----1', initialScaleFactor, svgValue, scaleFactorMaxTemp, scaleFactorMinTemp)

        if(initialScaleFactor && svgValue && svgValue.a && svgValue.a !== 1 && scaleFactorMaxTemp && scaleFactorMinTemp)  {
            setInitialScaleFactor(false);
            let svgZoomValue =  svgValue.a ;
            scaleFactorMaxTemp = scaleFactorMaxTemp ? scaleFactorMaxTemp*svgZoomValue : undefined;
            scaleFactorMinTemp = scaleFactorMinTemp ? scaleFactorMinTemp*svgZoomValue : undefined;

            if(scaleFactorMaxTemp || scaleFactorMinTemp){
                window.console.log('svgZoomValue---2', svgZoomValue, scaleFactorMaxTemp, scaleFactorMinTemp)
                setSvgValue({...svgValue, scaleFactorMax: scaleFactorMaxTemp, scaleFactorMin: scaleFactorMinTemp});
            }

            setMergedScaleFactor({
                scaleFactorMax: scaleFactorMaxTemp,
                scaleFactorMin: scaleFactorMinTemp,
            })
        }
    }, [scaleFactorMax, scaleFactorMin, mapColorSet, svgValue]);

    // 控制地图缩放
    const svgZoom = useMemo(() => {
        return mapZoom === undefined || mapZoom;
    }, [mapZoom]);

    // 控制地图移动
    const svgMove = useMemo(() => {
        return mapMove === undefined || mapMove;
    }, [mapMove]);

    // 控制可触摸
    const touchZoom = useMemo(() => {
        return touchable === undefined || touchable;
    }, [touchable]);

    // // 控制可拖拽
    // const svgSelectMode = useMemo(() => {
    //     return selectMode === undefined || selectMode;
    // }, [selectMode]);

    // 宽高集合
    const mapAllSize = useMemo(() => {
        // 额外需要增加的高度和宽度，目前用于留白边
        const extraWidth = mapExtraProps?.width || 0;
        const extraHeight = mapExtraProps?.height || 0;

        // 地图图片需要显示的宽度和高度
        const mapWidth = Number(baseMap?.width || componentWidth) + extraWidth;
        const mapHeight = Number(baseMap?.height || componentHeight) + extraHeight;

        return {
            extraWidth,
            extraHeight,
            mapWidth,
            mapHeight,
        };
    }, [mapExtraProps, componentWidth, componentHeight, baseMap]);

    //  const ViewerParent = useRef(null);
    // 使用 useImperativeHandle 暴露方法给父组件
    useImperativeHandle(ref, () => ({
        fitToViewerReSet,
        clearSelectElement,
        state: {
            mapElementState,
            baseMap,
            selectedEle: selectedEleState,
            showTip,
            path,
            start,
            end,
            path2,
            start2,
            end2,
            mapId: mapIdState,
            rateZoom,
            locationSvgMark,
            mapColorSet,
            allElements,
            selectedCenter: selectedCenterState,
            selectedArea: selectedAreaState,
            tool,
            svgValue,
            zoom,
            tipObj
        },
    }));

    const Viewer = useRef(null);

    const prevPropsRef = useRef(null);

    const loadMapData = useMemoizedFn((mapId) => {
        if(!customBaseMap){
            customGet(
                `/${defaultPath}virsical-map/map/${mapId}`,
                signatureKey,
                restfulSignature,
                token,
                requestPrefix,
                defaultPath
            )
                .then(({ data }) => {
                    reloadFinish();
                    if (data && data.code === 0) {
                        let objIcon = {};
                        let objColor = {};
                        if (data.data.icon) {
                            objIcon = JSON.parse(data.data.icon);
                        }
                        if (data.data.colors) {
                            objColor = JSON.parse(data.data.colors);
                        }

                        setBaseMap(data.data || {});
                        setLocationSvgMark(objIcon);
                        setMapColorSet(objColor);
                        // fitToViewer();
                    }
                })
                .catch(() => {
                    console.error('地图获取失败');
                });
        }
        // 加载地图上所有元素信息和元素位置信息
        if (!mapDataSource) {
            customGet(
                `/${defaultPath}virsical-map/map-element/list-slim?mapId=${mapId}&lang=${lang}&queryPath=${
                    showPath || appGetPathByUrl ? 1 : 0
                }`,
                signatureKey,
                restfulSignature,
                token,
                requestPrefix,
                defaultPath,
            )
                .then(({ data }) => {
                    if (data && data.code === 0) {
                        setMapElementState(data.data);
                        onElementsLoad(data.data);
                    }
                })
                .catch(() => {
                    console.error('地图元素获取失败');
                });
        }
        // 加载所有元素资源列表，包含元素状态
        customGet(
            `/${defaultPath}virsical-map/svg/enable-list-and-svg-state?mapId=${mapId}`,
            signatureKey,
            restfulSignature,
            token,
            requestPrefix,
            defaultPath,
        )
            // axios.get(`/virsical-map/svg/enable-list-and-svg-state`, { headers: { Authorization: token } })
            .then(({ data }) => {
                if (data && data.code === 0) {
                    setAllElements(data.data || []);
                    // fitToViewer();
                }
            })
            .catch(() => {
                console.error('素材列表获取失败');
            });
    });

    const mapElementsOnMap = useMemo(() => {
        let mapDataSourceList =
            mapDataSource && mapElementsList?.length > 0 ? mapElementsList : mapElementState;

        if (visibleElement?.length > 0) {
            // visibleElement 可显示的元素id集合
            mapDataSourceList = mapDataSourceList.filter((item) =>
                visibleElement?.includes(item?.mapElementId),
            );
        }

        if (visibleType?.length > 0) {
            // visibleType 可显示的元素类型集合
            mapDataSourceList = mapDataSourceList.filter((item) =>
                visibleType?.includes(item?.svgTypeCode),
            );
        }

        if (visibleState?.length > 0) {
            //visibleState 可显示的元素状态集合
            mapDataSourceList = mapDataSourceList?.filter((item) =>
                visibleState?.includes(item?.objectSvgStateCode),
            );
        }

        if (showStateIds?.length > 0) {
            //showStateIds 可显示的元素状态集合
            mapDataSourceList = mapDataSourceList?.filter((item) =>
                showStateIds?.some((itemB) => itemB?.id === item?.mapElementId),
            );
        }

        return mapDataSourceList;
    }, [
        mapDataSource,
        mapElementsList,
        visibleElement,
        visibleType,
        visibleState,
        showStateIds,
        mapElementState,
    ]);

    // 引导线样式
    const showPathStyle = useMemo(() => {
        let showPathStyle = {
            stroke: mapColorSet?.guidesRgb || '#00ba00',
            strokeWidth: mapColorSet?.guidesWidth ? `${mapColorSet?.guidesWidth}px` : '5px',
            opacity: mapColorSet?.guidesTransparent || '1',
        };
        if (Object.keys(pathStyle).length > 0) {
            showPathStyle = {
                stroke: pathStyle.stroke || '#00ba00',
                strokeWidth: pathStyle.strokeWidth || '5px',
                opacity: pathStyle.opacity || '1',
            };
        }
        return showPathStyle;
    }, [mapId, pathStyle, mapColorSet]);

    // 第二条引导线样式
    const showPathStyle2 = useMemo(() => {
        if (Object.keys(pathExStyle).length > 0) {
            return {
                stroke: pathExStyle.stroke || '#CE3AC2',
                strokeWidth: pathExStyle.strokeWidth || '5px',
                opacity: pathExStyle.opacity || '1',
            };
        }
    }, [pathExStyle])

    // 引导线信息
    // const pathInfo = useMemo(() => {
    //     let startPath = state?.start;
    //     let endPath = state?.end;
    //     let pathInfo = state?.path;
    //     if (showPath && mapElementsOnMap && markId) {
    //         const searchMapEle = mapElementsOnMap?.find((element) => String(element.mapElementId) === String(markId));
    //         if (searchMapEle && Object.prototype.hasOwnProperty.call(searchMapEle, pathLineKey?.mid) && searchMapEle[pathLineKey?.mid]) {
    //             pathInfo = searchMapEle[pathLineKey?.mid];
    //             startPath = {
    //                 x: searchMapEle[pathLineKey?.start].split(",")[0],
    //                 y: searchMapEle[pathLineKey?.start].split(",")[1],
    //             };
    //             endPath = {
    //                 x: searchMapEle[pathLineKey?.end].split(",")[0],
    //                 y: searchMapEle[pathLineKey?.end].split(",")[1],
    //             };
    //         } else {
    //             pathInfo = "";
    //             startPath = null;
    //             endPath = null;
    //         }
    //     }
    //
    //     window.console.log("pathInfo", pathInfo, startPath, endPath)
    //
    //     return {pathInfo, startPath, endPath};
    //
    // }, [showPath, markId]);

    useLayoutEffect(() => {
        Viewer.current.fitToViewer();
    }, []);

    useEffect(()=>{
        if(customBaseMap){
            setBaseMap(customBaseMap);
            let objIcon = {};
            let objColor = {};
            if (customBaseMap?.icon) {
                objIcon = JSON.parse(customBaseMap?.icon);
            }
            if (customBaseMap?.colors) {
                objColor = JSON.parse(customBaseMap?.colors);
            }
            setLocationSvgMark(objIcon);
            setMapColorSet(objColor);
            reloadFinish();
        }
    },[customBaseMap])

    // 切换地图id时重新加载地图
    useEffect(() => {
        if (mapId !== undefined && mapId !== mapIdState) {
            loadMapData(mapId);
            setSelectedEleState([]);
            setShowTip(false);
            setPath('');
            setStart(null);
            setEnd(null);
            setPath2('');
            setStart2(null);
            setEnd2(null);
            setMapIdState(mapId);
            setInitialScaleFactor(true);
        }
        getSVGViewer();
    }, [mapId]);

    // 当调用重新加载地图时，reloadMap传true
    useEffect(() => {
        if (reloadMap) {
            setSelectedEleState([]);
            setShowTip(false);
            setPath('');
            setStart(null);
            setEnd(null);
            setPath2('');
            setStart2(null);
            setEnd2(null);
            loadMapData(mapId);
        }
    }, [reloadMap]);

    // deleteId 删除选中元素
    useEffect(() => {
        if (deleteId !== '') {
            deleteSelect(deleteId);
        }
    }, [deleteId]);

    // 选中元素变更
    useEffect(() => {
        if (selectedEle !== undefined && Array.isArray(selectedEle)) {
            setSelectedEleState(selectedEle.length > 0 ? selectedEle : []);

            if (typeof setSelectedEleFinish === 'function') {
                setSelectedEleFinish();
            }

            //    window.console.log('selectedEle333333333333333222', selectedEle)
        }
    }, [selectedEle]);

    // 选中元素id变更
    useEffect(() => {
        if (mapElementsOnMap?.length > 0 && selectedIds?.length > 0) {
            const eles = [];
            mapElementsOnMap?.length > 0 &&
            mapElementsOnMap.forEach((d) => {
                if (selectedIds.includes(d.mapElementId)) {
                    eles.push({ ...d });
                }
            });
            setSelectedEleState(eles);
        }
    }, [selectedIds, mapElementsOnMap]);

    // 显示路径
    useEffect(() => {
        if (!showPath || !markId) {
            setPath('');
            setStart(null);
            setEnd(null);
            setPath2('');
            setStart2(null);
            setEnd2(null);
        }
    }, [showPath, markId]);

    // 多选/单选 切换时清空选择，后面考虑要不要
    useEffect(() => {
        if (!multiple && selectedEleState?.length > 0) {
            //    window.console.log('multiple--clearSelectElement333333333333333555', multiple, selectedEleState)
            clearSelectElement();
        }
    }, [multiple]);

    // 批量操作资源类型切换时清空选择
    useEffect(() => {
        if (multiple && selectMode && selectableType !== undefined && selectedEleState?.length > 0) {
            //  window.console.log('selectableType--clearSelectElement333333333333333555', selectMode, multiple, selectedEleState)
            clearSelectElement();
        }
    }, [selectableType]);

    // 放大缩小
    useEffect(() => {
        if (zoomRate !== undefined && Viewer?.current) {
            let newRateZoom = zoomRate;
            if (mergedScaleFactor.scaleFactorMax && newRateZoom > mergedScaleFactor.scaleFactorMax) {
                newRateZoom = mergedScaleFactor.scaleFactorMax;
            }
            if (mergedScaleFactor.scaleFactorMin && newRateZoom < mergedScaleFactor.scaleFactorMin) {
                newRateZoom = mergedScaleFactor.scaleFactorMin;
            }

            setRateZoom(newRateZoom);
        }
    }, [zoomRate, Viewer]);

    // 设置元素剧中，根据markId和showPath的变化获取路径
    useEffect(() => {
        if (
            prevPropsRef?.current?.centerElement &&
            prevPropsRef?.current?.centerElement?.mapElementId !== centerElement?.mapElementId &&
            centerElement?.hasOwnProperty('stationx') &&
            centerElement?.hasOwnProperty('stationy')
        ) {
            setEleToCenter(centerElement);
        } else if (prevPropsRef?.current?.centerElement?.mapElementId !== centerElement?.mapElementId) {
            //  window.console.log('cancel-centerElement', centerElement);
            fitToViewerReSet();
        }

        //  window.console.log('showPath', showPath, markId);
        // 根据markId和showPath的变化获取路径
        if (
            markId !== prevPropsRef?.current?.markId &&
            showPath &&
            markId &&
            !(typeof markId === 'object' && Array.isArray(markId))
        ) {
            getMapElePath(markId);
        }

        // 更新prevPropsRef以供下次比较
        prevPropsRef.current = { centerElement, markId, showPath };
    }, [centerElement, markId, showPath]);

    // fitToViewer
    useEffect(() => {
        fitToViewerReSet();
     //   window.console.log('fitToViewer-mergedScaleFactor',svgValue);
    }, [baseMap?.width, baseMap?.height, rateZoom, zoomRate, Viewer]);


    const fitToViewerReSet = () => {
        Viewer.current.fitToViewer();
        //  window.console.log('fitToViewer-mergedScaleFactor',Viewer.current.getValue());
        let {
            height,
            width,
        } = baseMap;
        let zoom = 1;
        let mapWidth = Number(width);
        let mapHeight = Number(height);
        let curRate = rateZoom || zoomRate;

        //  window.console.log('fitToViewer width height', width, height, Viewer)
        /*
            适配规则
            zoomHeight: 画布与地图底图高度比例；
            zoomWidth： 画布于地图底图宽度比例；
            zoomHeight < zoomWidth 则按高度适配，以高度比例缩放；
            zoomHeight > zoomWidth 则按宽度适配，以宽度比例缩放；
            */
        if (height && width) {
            const mapHeight = Number(height);
            const mapWidth = Number(width);
            const zoomHeight = Number(componentHeight) / Number(mapHeight);
            const zoomWidth = Number(componentWidth) / Number(mapWidth);
            if (zoomHeight < zoomWidth) {
                zoom = zoomHeight;
            } else {
                zoom = zoomWidth;
            }
        }

        if (legendList.length > 0) {
            mapHeight += 100;
        }
        // console.log('fitToViewer width height', width, height)
        Viewer.current.setPointOnViewerCenter(
            (Number(mapWidth) || DEFAULT_WIDTH) / 2,
            (Number(mapHeight) || DEFAULT_HEIGHT) / 2,
            zoom * curRate || dpr,
        );
    };

    // 取消选中
    const deleteSelect = (id) => {
        const newSelectedEle = selectedEleState.filter((item) => String(item.mapElementId) !== String(id));
        setSelectedEleState(newSelectedEle);
        if (typeof deleteFinish === 'function') {
            deleteFinish();
        }
    };

    const clearSelectElement = () => {
        window.console.log('clearSelectElement--clearSelectElement');
        setSelectedEleState([]);
        setPath('');
        setStart(null);
        setEnd(null);
        setPath2('');
        setStart2(null);
        setEnd2(null);
        if (typeof onSelect === 'function') {
            onSelect([]);
        }
        if (typeof onClick === 'function') {
            onClick({}, []);
        }
    };

    // 设定特定元素到屏幕中间
    const setEleToCenter = (element) => {
        if (element.stationx && element.stationy && Viewer) {
            Viewer.current.setPointOnViewerCenter(
                Number(element.stationx) + Number(element?.customElementWidth || 0) / 2,
                Number(element.stationy) + Number(element?.customElementHeight || 0) / 2,
                centerEleRate,
            );
        } else {
            window.console.warn('setEleToCenter element miss stationx & stationy.');
        }
    };

    // 获取svg的ViewerDOM
    const getSVGViewer = () => {
        if (typeof getSvgDom === 'function') {
            if (Viewer && Viewer?.current?.ViewerDOM) {
                getSvgDom(Viewer?.current?.ViewerDOM);
            }
        }
    };

    // 根据mapElementId获取元素详情-路劲信息
    const getMapElePath = (mapElement) => {
        let getPathUrl = `/${defaultPath}virsical-map/map-element/${mapElement}`;
        if(isDoubleMap){
            getPathUrl = `/${defaultPath}virsical-map/map-element/${mapElement}?isCf=1`;
        }
        // 加载地图基础信息
        customGet(
            getPathUrl,
            signatureKey,
            restfulSignature,
            token,
            requestPrefix,
            defaultPath,
        ).then(({ data }) => {
            let start = null;
            let end = null;
            let path = '';
            let start2 = null;
            let end2 = null;
            let path2 = '';
            if (data?.data && data?.data[pathLineKey.mid]) {
                path = data?.data[pathLineKey.mid];
                start = {
                    x: data?.data[pathLineKey.start].split(',')[0],
                    y: data?.data[pathLineKey.start].split(',')[1],
                };
                end = {
                    x: data?.data[pathLineKey.end].split(',')[0],
                    y: data?.data[pathLineKey.end].split(',')[1],
                };
            } else {
                path = '';
                start = null;
                end = null;
            }
            if(!isDoubleMap && data?.data && data?.data[path2LineKey.mid] ) {
                path2 = data?.data[path2LineKey.mid];
                start2 = {
                    x: data?.data[path2LineKey.start].split(',')[0],
                    y: data?.data[path2LineKey.start].split(',')[1],
                };
                end2 = {
                    x: data?.data[path2LineKey.end].split(',')[0],
                    y: data?.data[path2LineKey.end].split(',')[1],
                };
            } else {
                path2 = '';
                start2 = null;
                end2 = null;
            }
            handleGetPathInfo(data?.data, isDoubleMap);
            setPath(path);
            setStart(start);
            setEnd(end);
            setPath2(path2);
            setStart2(start2);
            setEnd2(end2);

            // if(guideFirstSvg && document.getElementById("animBall1Show")){
            //   document.getElementById("animBall1Show").beginElement();
            // }

        }).catch(() => {
            console.error('路径获取失败');
        });
    };

    // touch 空白处隐藏 tooltip
    const onTouchStart = (e) => {
        // 支持 touch 事件，用地图空白处 TouchStart 取消 tooltip
        if (HAVE_TOUCH_EVENT) {
            e.stopPropagation();
            // 判断默认行为是否可以被禁用
            if (e.cancelable) {
                // 判断默认行为是否已经被禁用
                if (!e.defaultPrevented) {
                    e.preventDefault();
                }
            }
            setShowTip(false);
        }
    };

    // 获取选择区域内的元素
    const setSelectElements = () => {
        if (!selectableType) {
            return;
        }
        const selectedAreaData = selectedAreaState;
        const stateSelectedEle = selectedEleState;
        const allElementsData = allElements;

        const { x, y, dragWidth, dragHeight } = selectedAreaData;
        const selectList = [];
        const clickFlag = (ele) => !clickableElement || clickableElement?.includes(ele.mapElementId);

        mapElementsOnMap.forEach((ele) => {
            if (clickFlag(ele) && ele.svgTypeCode === selectableType) {
                const eleSvg =
                    allElementsData && allElementsData.find((e) => String(e.svgId) === String(ele?.svgId));
                let centerx = Number(ele.stationx) + Number(eleSvg.svgWidth) / 2;
                let centery = Number(ele.stationy) + Number(eleSvg.svgHeight) / 2;
                if (centerx >= x && centerx <= x + dragWidth && centery >= y && centery <= y + dragHeight) {
                    selectList.push(ele);
                }
            }
        });

        // window.console.log(
        //   selectList,
        //   selectedEleState,
        //   selectedAreaData,
        //   x + dragWidth,
        //   y + dragHeight,
        //   mapElementsOnMap,
        //   'onMouseDown3333333333333333333333332222',
        // );

        selectList.sort(compare('stationy', 'stationx'));

        // 多次拖拽获取集合差
        const selectNewList = findAndCombineDifferences(stateSelectedEle, selectList);

        setSelectedEleState(selectNewList);

        onSelect(selectNewList);

        setSelectedAreaState({ x: 0, y: 0, dragWidth: 0, dragHeight: 0 });
    };

    // 设置选择区域中心点
    const setSelectedCenter = ({ x, y }) => {
        setSelectedCenterState({ x, y });
    };

    // 设置选择区域大小
    const setSelectedArea = ({ dragX, dragY }) => {
        const { x, y } = selectedCenterState;
        let centerX = x;
        let centerY = y;
        const dragWidth = Math.abs(x - dragX);
        const dragHeight = Math.abs(y - dragY);
        if (dragX < x && dragY < y) {
            centerX = dragX;
            centerY = dragY;
        } else if (dragX > x && dragY < y) {
            centerY = dragY;
        } else if (dragX < x && dragY > y) {
            centerX = dragX;
        }
        //  window.console.log('setSelectedArea', x, y, dragX, dragY, centerX, centerY, dragWidth, dragHeight)
        setSelectedAreaState({ x: centerX, y: centerY, dragWidth, dragHeight });
    };

    // 选择地图上的元素
    const onClickHandle = (element, visible = true) => {
        window.console.log(element, 'onClickHandle');
        const selectedEle = selectedEleState;
        // 不显示的元素不能点击，返回错误码100
        if (!visible) {
            onClickError(100, element);
            return;
        }

        // 判断元素的id是否可以选中，返回错误码101
        if (
            clickableElement &&
            (clickableElement.length === 0 ||
                (clickableElement.length > 0 &&
                    !clickableElement.some((v) => String(v) === String(element.mapElementId))))
        ) {
            onClickError(101, element);
            return;
        }
        // 判断元素的类型是否可以选中（如：工位，会议室等），返回错误码102
        if (
            clickableType &&
            (clickableType.length === 0 ||
                (clickableType.length > 0 && !clickableType.some((v) => v === element.svgTypeCode)))
        ) {
            onClickError(102, element);
            return;
        }
        // 判断元素的状态是否可以选中（如：空闲，占用等），返回错误码103
        if (
            clickableState &&
            (clickableState.length === 0 ||
                (clickableState.length > 0 &&
                    !clickableState.some((v) => v === element.objectSvgStateCode)))
        ) {
            onClickError(103, element);
            return;
        }

        // 只能批量操作必须选择类型
        if (multiple && !selectableType) {
            onClickError(105, element);
            return;
        }

        // 只能多选同类型的元素，返回错误码104
        if (multiple && element.svgTypeCode !== selectableType) {
            if (typeof onClickError === 'function') {
                onClickError(104, element);
            }
            return;
        }

        // 判断点击的素材是否是绑定区域的，是则返回mapId
        if (mapSpaceJump && element.extend) {
            let mapObj = JSON.parse(element.extend);
            let stateObj = showStateIds.find((o) => String(o.id) === String(element.mapElementId)) || {};
            if (stateObj && stateObj[0] && stateObj[0].extend) {
                mapObj = JSON.parse(stateObj[0]);
            }
            reSetMapId(mapObj);
            return;
        }

        const index = selectedEle.findIndex((item) => item.mapElementId === element.mapElementId);
        if (index >= 0) {
            // 从列表中删除
            selectedEle.splice(index, 1);
        } else {
            // 如果不允许多选，需要先删除选择的工位
            !multiple && selectedEle.splice(0, selectedEle.length);
            // 增加一个工位
            selectedEle.push(element);
        }
        setSelectedEleState([...selectedEle]);
        // 多选返回，每次返回所有选中的对象
        if (typeof onSelect === 'function') {
            onSelect(selectedEle);
        }
        // 单选返回，如果是多选模式，会返回刚选中的对象
        if (typeof onClick === 'function') {
            onClick(element, selectedEle);
            // 如果是单选并且打开点击素材剧中放大
            if (clickToCenter && selectedEle.length > 0) {
                element.customElementWidth = element?.axisx;
                element.customElementHeight = element?.axixy;
                setEleToCenter(element);
            }
        }
    };

    // 渲染地图上元素集合 - 使用useMemo优化性能
    const renderElements = useMemoizedFn((element) => {
        const selectedEle = selectedEleState;
        const baseMapData = baseMap;
        // 找到地图上元素对应的素材
        const eleSvg =
            allElements && allElements.find((e) => String(e.svgId) === String(element?.svgId));
        // 2、结合素材文件，渲染地图上元素
        let svgContent = <g key={element.mapElementId} />;
        let genders = ''; // 男女，外包人员前加头像
        if (!eleSvg) {
            if (Number(element.svgId) === 0) {
                return renderElementsArea(element);
            }
            return svgContent;
        }
        let cursorProps = {cursor: 'pointer'};
        if (
            isNotAllowedEle &&
            (!clickableElement || !clickableElement?.includes(element.mapElementId))
        ) {
            cursorProps = { cursor: 'not-allowed' };
        }

        if (eleSvg?.viewBox) {
            svgContent = (
                <svg viewBox={eleSvg.viewBox} width={eleSvg.svgWidth || 0} height={eleSvg.svgHeight || 0}>
                    <g {...cursorProps} dangerouslySetInnerHTML={{ __html: eleSvg.svgElement }} />
                </svg>
            );
        } else {
            svgContent = <g {...cursorProps} dangerouslySetInnerHTML={{ __html: eleSvg?.svgElement }} />;
        }
        // 3、渲染元素上需要显示的文字以及计算文字的旋转角度，需要保持文字正向显示
        let contentText = element?.objectName || '';
        let defaultTooltipKeyName = '';
        let tooltipObj = '';
        let contentSvg = '';
        let offset = [Number(eleSvg.axisx) || 0, Number(eleSvg.axixy) || 0];
        let center = [Number(eleSvg.svgWidth) / 2, Number(eleSvg.svgHeight) / 2];

        let groupRotate = Number(element?.cycleValue) % 360;
        if (groupRotate < 0) {
            groupRotate += 360;
        }
        let rotate = 0;
        if ((groupRotate >= 0 && groupRotate < 90) || (groupRotate >= 270 && groupRotate <= 360)) {
            rotate = 0;
        } else if (groupRotate >= 90 && groupRotate < 270) {
            rotate = 180;
        }

        // 4、修改元素的透明度
        let opacity = 1;
        // 5、渲染元素的颜色，如果对应的素材不支持修改颜色，则替换对应状态的素材
        let fill = COLOR_DEFAULT;

        // 特殊状态文字颜色
        let textColorByState = null;

        // 20210616 新增设置素材状态颜色和透明度，objectColor如果不为空，并且以#开头，则为设置的素材颜色；不为空并且不已#开头，根据objectColor的内容去查找素材状态颜色；否则为默认颜色
        if (element?.objectColor) {
            if (element?.objectColor.startsWith('#')) {
                fill = element?.objectColor;
            } else if (element?.objectColor === 'free') {
                opacity = mapColorSet?.freeTransparent || 1;
                fill = mapColorSet?.freeRgb || '#69E5A5';
            } else if (element?.objectColor === 'busy') {
                opacity = mapColorSet?.busyTransparent || 1;
                fill = mapColorSet?.busyRgb || '#FD7C7C';
            } else if (element?.objectColor === 'disabled') {
                opacity = mapColorSet?.disabledTransparent || 1;
                fill = mapColorSet?.disabledRgb || '#D1D8DF';
            } else if (element?.objectColor === 'onHold') {
                opacity = mapColorSet?.onHoldTransparent || 1;
                fill = mapColorSet?.onHoldRgb || '#1110EF';
            } else if (element?.objectColor === 'unreserved') {
                opacity = mapColorSet?.unreservedTransparent || 1;
                fill = mapColorSet?.unreservedRgb || '#FFB26A';
            }
        } else if (!element?.objectId && isShowSvgDefaultColor) {
            // 未绑定素材显示默认颜色
            fill = eleSvg.svgColor || COLOR_DEFAULT;
        }

        const customStyle = elementsColor.length > 0;
        // 如果组件没有传进样式，按默认显示，如果有传参数，按参数修改
        if (!showStateIds && !customStyle) {
            if (selectedEle.some((item) => item.mapElementId === element.mapElementId)) {
                fill = COLOR_SELECTED;
            }
            if (element.svgStateElement) {
                if (eleSvg.viewBox) {
                    svgContent = (
                        <svg
                            viewBox={eleSvg.viewBox}
                            width={eleSvg.svgWidth || 0}
                            height={eleSvg.svgHeight || 0}
                        >
                            <g dangerouslySetInnerHTML={{ __html: element?.svgStateElement }} />
                        </svg>
                    );
                } else {
                    svgContent = <g dangerouslySetInnerHTML={{ __html: element?.svgStateElement }} />;
                }
            }
        } else {
            // 如果组件外部传入主动变更状态的集合，则替换响应的状态元素
            let stateObj = showStateIds.find((o) => String(o.id) === String(element.mapElementId)) || {};
            // 通过elementsColor传入的颜色优先级高
            if (customStyle) {
                const tmpCustomStyle =
                    elementsColor.find((o) => String(o.id) === String(element.mapElementId)) || {};
                stateObj = { ...stateObj, ...tmpCustomStyle };
            }

            if (stateObj) {
                contentText = stateObj?.text || '';
                // 如果设置了颜色按相应颜色显示
                if (stateObj?.color) {
                    if (stateObj?.color.startsWith('#')) {
                        fill = stateObj?.color;
                    } else if (stateObj?.color === 'free') {
                        opacity = mapColorSet?.freeTransparent || 1;
                        fill = mapColorSet?.freeRgb || '#69E5A5';
                    } else if (stateObj?.color === 'busy') {
                        opacity = mapColorSet?.busyTransparent || 1;
                        fill = mapColorSet?.busyRgb || '#FD7C7C';
                    } else if (stateObj?.color === 'disabled') {
                        opacity = mapColorSet?.disabledTransparent || 1;
                        fill = mapColorSet?.disabledRgb || '#D1D8DF';
                    } else if (stateObj?.color === 'onHold') {
                        opacity = mapColorSet?.onHoldTransparent || 1;
                        fill = mapColorSet?.onHoldRgb || '#1110EF';
                    } else if (stateObj?.color === 'unreserved') {
                        opacity = mapColorSet?.unreservedTransparent || 1;
                        fill = mapColorSet?.unreservedRgb || '#FFB26A';
                    }
                } else {
                    // color 不存在，则显示默认颜色
                    fill = COLOR_DEFAULT;
                    if (!stateObj?.contentObj?.objectId && isShowSvgDefaultColor) {
                        // 未绑定素材显示默认颜色
                        fill = eleSvg.svgColor || COLOR_DEFAULT;
                    }
                }
                // console.log('customStyle stateObj', fill, stateObj)
                if (!_.isEmpty(stateObj.contentObj)) {
                    if (isGenders && stateObj.contentObj.userName) {
                        if (Number(stateObj.genders) === 1) {
                            genders = '👨';
                        } else if (Number(stateObj.genders) === 2) {
                            genders = '👩';
                        } else if (Number(stateObj.genders) === 3) {
                            genders = '‍👨‍💻';
                        }
                    }
                    tooltipObj = stateObj.contentObj;
                    defaultTooltipKeyName = tooltipObj[defaultTooltipKey];
                }
                if (eleSvg.svgStateList && eleSvg.svgStateList.length > 0) {
                    // 如果有状态根据状态显示相应素材
                    const eleState = eleSvg.svgStateList.find((d) => {
                        return d.svgStateCode === stateObj.state;
                    });
                    if (eleState) {
                        fill = null;
                        textColorByState = stateObj?.textColorByState || '#000';
                        if (eleSvg.viewBox) {
                            svgContent = (
                                <svg
                                    viewBox={eleSvg.viewBox}
                                    width={eleSvg.svgWidth || 0}
                                    height={eleSvg.svgHeight || 0}
                                >
                                    <g
                                        dangerouslySetInnerHTML={{
                                            __html: eleState.svgStateElement,
                                        }}
                                    />
                                </svg>
                            );
                        } else {
                            svgContent = <g dangerouslySetInnerHTML={{ __html: eleState.svgStateElement }} />;
                        }
                    }
                }
            }
        }

        // 7、添加被搜索元素的标记
        let markIcon = '',
            markOnlyId = '';
        if (typeof markId === 'object' && Array.isArray(markId)) {
            // markId.forEach((m) => {
            //     if (String(m) === String(element.mapElementId)) {
            //         window.console.log("markId", m, element.mapElementId)
            //         markOnlyId = m;
            //     }
            // });
            if (markId?.includes(element.mapElementId)) {
                markOnlyId = element.mapElementId;
            }
        } else if (markId === String(element.mapElementId)) {
            markOnlyId = markId;
        }

        if (markOnlyId && String(markOnlyId) === String(element.mapElementId)) {
            const param = {
                rotate: Number(element?.cycleValue) || 0,
                width: Number(eleSvg.svgWidth) || 0,
                height: Number(eleSvg.svgHeight) || 0,
                mapElementId: element.mapElementId || null,
                eleSvg,
                element,
            };

            if (locationSvgMark && locationSvgMark.element) {
                let svgWidth = '';
                let svgHeight = '';
                if (locationSvgMark?.viewBox) {
                    const viewSize = locationSvgMark?.viewBox.split(' ') || [];
                    svgWidth = (viewSize?.length === 4 && viewSize[2]) || '';
                    svgHeight = (viewSize?.length === 4 && viewSize[3]) || '';
                }
                const objParam = Object.assign({}, { ...param }, { svgWidth, svgHeight });
                markIcon = (
                    <MarkIcon
                        {...objParam}
                        svgPath={() => {
                            return (
                                <g
                                    dangerouslySetInnerHTML={{
                                        __html: locationSvgMark.element,
                                    }}
                                />
                            );
                        }}
                    />
                );
            }
            if (markSvg) {
                markIcon = <MarkIcon {...param} svgPath={markSvg} />;
            }

            if (!locationSvgMark?.element && !markSvg) {
                markIcon = <MarkIcon {...param} />;
            }

            //   window.console.log("markId", markOnlyId, element.mapElementId, markIcon);
        }

        // 8、添加被选中元素的标记
        let selectedIcon = '',
            selectedId = '',
            selectedKey = '';
        selectedEle.forEach((s, index) => {
            if (s.mapElementId === element.mapElementId) {
                selectedKey = (Number(index) + 1).toString();
                selectedId = s.mapElementId;
            }
        });
        if (selectedId && String(selectedId) === String(element.mapElementId)) {
            const param = {
                rotate: Number(element?.cycleValue) || 0,
                width: Number(eleSvg?.svgWidth) || 0,
                height: Number(eleSvg?.svgHeight) || 0,
                text: selectedKey || '',
                multiple,
            };

            selectedIcon = <SelectedIcon {...param} svgPath={selectedSvg} />;
        }
        // console.log('renderElements',  element.svgTypeCode, visible)
        // 渲染
        let textRole = 0;
        if (eleSvg?.direction !== -1 && element?.cycleValue) {
            textRole = Number(eleSvg?.direction) - Number(element?.cycleValue);
        }

        if (eleSvg?.direction === -1 && Number(element?.cycleValue) === 180) {
            // 优化：缓存文本测量结果，避免频繁DOM操作
            const textKey = `${contentText}_${eleSvg.fontSize || 12}`;
            let sizeD = textMeasurementCache.get(textKey);

            if (!sizeD) {
                const spanDom = document.createElement('span');
                spanDom.style.fontSize = `${eleSvg.fontSize || 12}px`;
                spanDom.style.opacity = '0';
                spanDom.style.fontFamily = 'ArialMT';
                spanDom.style.textAnchor = 'middle';
                spanDom.innerHTML = contentText;
                document.body.appendChild(spanDom);
                sizeD = {
                    height: spanDom.offsetHeight,
                    width: spanDom.offsetWidth
                };
                spanDom.remove();
                textMeasurementCache.set(textKey, sizeD);
            }

            textRole = 180;
            center[0] = Number(eleSvg.axisx);
            center[1] = Number(eleSvg.axixy);
            offset[1] += sizeD.height / 2;
        }

        if (Number(eleSvg.direction) === 180) {
            textRole = 180;
            center[0] = Number(eleSvg.axisx);
            center[1] = Number(eleSvg.axixy);
        } else if (Number(eleSvg.direction) !== -1) {
            textRole = eleSvg.direction;
            center[0] = Number(eleSvg.axisx) / 2;
            center[1] = Number(eleSvg.axixy) / 2;
        }

        if (eleSvg.direction !== -1 && element?.cycleValue) {
            textRole = Number(eleSvg.direction) - Number(element?.cycleValue);
            // offset = [Number(eleSvg.axisx) || 0, Number(eleSvg.axixy) || 0];
            // center = [Number(eleSvg.svgWidth) / 2, Number(eleSvg.svgHeight) / 2];
        }

        // 9、添加根据状态标记元素的标记
        let markStateIcon = '';
        if (markStateId && markStateId.length > 0) {
            markStateId.forEach((m) => {
                if (String(m) === String(element.mapElementId)) {
                    const param = {
                        rotate: Number(element?.cycleValue) || 0,
                        width: Number(eleSvg.svgWidth) || 0,
                        height: Number(eleSvg.svgHeight) || 0,
                    };
                    markStateIcon = <MarkIcon {...param} svgPath={markStateSvg} />;
                }
            });
        }

        // 文字颜色
        const { fontColor } = baseMapData;
        let textShowColor = fontColor || '#fff';
        if (eleSvg.fontColor) {
            textShowColor = eleSvg.fontColor;
        }
        if (textColor) {
            textShowColor = textColor;
        }
        if (textColorByState) {
            textShowColor = textColorByState;
        }

        // hideNameType 是否有不显示内容的素材类型
        let hideName = false;
        if (hideNameType?.length > 0) {
            if (hideNameType.indexOf(element.svgTypeCode) !== -1) {
                hideName = true;
            }
        }

        const tipObjName = {
            contentSvg: contentSvg,
            name: Array.isArray(contentText) ? contentText[0] : contentText,
            width: Number(element?.customElementWidth) / 2 || 0,
            height: Number(element?.customElementHeight) / 2 || 0,
            x: Number(element?.stationx) || 0,
            y: Number(element?.stationy) || 0,
        };

        // 是否使用tooltip显示名称
        const bNameVisible =
            isTextToolTip &&
            ((textToolTipList?.length > 0 && textToolTipList.some((v) => v === element.mapElementId)) ||
                textToolTipList?.length === 0);

        // 检查color并进行处理,兼容透明度,后端svg下载pdf方法不支持rgba
        const { rgbHex, alphaDecimal} = parseColorWithAlpha(fill);
        fill = rgbHex || fill;
        opacity = alphaDecimal || opacity;

        return (
            <g
                key={element.mapElementId}
                elementId={element.mapElementId}
                strokeWidth="1"
                cursorProps={cursorProps}
                fill={fill}
                fillOpacity={opacity}
                transform={`
          translate(${element?.stationx || 0}, ${element?.stationy || 0})
          scale(1, 1)
          rotate(
              ${element?.cycleValue || 0},
              ${(Number(eleSvg.svgWidth) || 0) / 2},
              ${(Number(eleSvg.svgHeight) || 0) / 2}
          )
        `}
                onMouseEnter={(e) => {
                    // 鼠标移动到元素上，显示气泡框
                    // console.log('鼠标进入 事件触发')
                    if (!HAVE_TOUCH_EVENT) {
                        // 不支持 touch 事件，用 mouseEnter 触发 tooltip
                        if (typeof tooltipContent === 'function') {
                            contentSvg = tooltipContent(tooltipObj);
                        }
                        setTipObj({
                            contentSvg: contentSvg,
                            name: defaultTooltipKeyName,
                            width: Number(eleSvg.svgWidth) || 0,
                            height: Number(eleSvg.svgHeight) || 0,
                            x: Number(element?.stationx) || 0,
                            y: Number(element?.stationy) || 0,
                        });
                        setShowTip(true);
                    }
                }}
                onMouseLeave={() => {
                    // 鼠标从元素上移开，关闭气泡框
                    // console.log('鼠标离开 事件触发')
                    // 不支持 touch 事件，用 mouseLeave 取消 tooltip
                    if (!HAVE_TOUCH_EVENT) {
                        setShowTip(false);
                    }
                }}
                onTouchEnd={(e) => {
                    if (isTouchDevice) {
                        e.preventDefault();
                        e.stopPropagation();
                        onClickHandle(element, true);
                    }
                }}
                onTouchStart={(e) => {
                    // 触屏端触发
                    // console.log('Touch 事件触发')
                    // 支持 touch 事件，用 TouchStart 触发 tooltip
                    if (windowsTouchSupport || HAVE_TOUCH_EVENT) {
                        e.stopPropagation();
                        // 判断默认行为是否可以被禁用
                        if (e.cancelable) {
                            // 判断默认行为是否已经被禁用
                            if (!e.defaultPrevented) {
                                e.preventDefault();
                            }
                        }
                        if (typeof tooltipContent === 'function') {
                            contentSvg = tooltipContent(tooltipObj);
                        }
                        setTipObj({
                            contentSvg: contentSvg,
                            name: defaultTooltipKeyName,
                            width: Number(eleSvg.svgWidth) || 0,
                            height: Number(eleSvg.svgHeight) || 0,
                            x: Number(element?.stationx) || 0,
                            y: Number(element?.stationy) || 0,
                        });
                        setShowTip(true);
                    }
                }}
                onClick={() => {
                    onClickHandle(element, true);
                }}
            >
                {elementRenderHandle ? elementRenderHandle(svgContent, element, { eleSvg }) : svgContent}
                {!noName && !hideName && eleSvg?.displayText !== 0 && contentText && (
                    Array.isArray(contentText) ? (
                        // 多行显示：当contentText是数组时，显示位置以第一行为主
                        <g transform={`rotate(${textRole}, ${center[0]}, ${center[1]})`}>
                            {contentText?.map((textLine, index) => {
                                const fontSize = eleSvg.fontSize || 12;
                                const lineHeight = fontSize * 1.2;
                                // 显示位置以第一行为主，第一行在原始位置，后续行依次向下排列
                                const startY = offset[1];

                                return (
                                    <SvgTextEllipsis
                                        key={index}
                                        dx={offset[0]}
                                        dy={startY + index * lineHeight}
                                        cursorProps={cursorProps}
                                        fill={textShowColor}
                                        fillOpacity={1}
                                        fontFamily="ArialMT"
                                        textAnchor="middle"
                                        fontSize={fontSize}
                                        width={Number(eleSvg.svgWidth) || 0}
                                    >
                                        {index === 0 ? genders + textLine : textLine}
                                    </SvgTextEllipsis>
                                );
                            })}
                        </g>
                    ) : (
                        // 单行显示：当contentText是字符串时
                        <SvgTextEllipsis
                            transform={`rotate(${textRole}, ${center[0]}, ${center[1]})`}
                            dx={offset[0]}
                            dy={offset[1]}
                            cursorProps={cursorProps}
                            fill={textShowColor}
                            fillOpacity={1}
                            fontFamily="ArialMT"
                            textAnchor="middle"
                            fontSize={eleSvg.fontSize || 12}
                            width={Number(eleSvg.svgWidth) || 0}
                        >
                            {genders + contentText}
                        </SvgTextEllipsis>
                    )
                )}
                {elementRenderTextAfterHandle &&
                    elementRenderTextAfterHandle(svgContent, element, { contentText, eleSvg })}
                {markStateIcon}
                {markIcon}
                {selectedIcon}
                {bNameVisible && (
                    <ToolTipName
                        showTip={true}
                        tipObj={tipObjName}
                        zoom={zoom}
                        textToolTipRender={
                            textToolTipRender
                                ? () => {
                                    return textToolTipRender(tipObjName, element);
                                }
                                : undefined
                        }
                    />
                )}
            </g>
        );
    });

    // 渲染地图上区域元素
    const renderElementsArea = useMemoizedFn((element) => {
        const selectedEle = selectedEleState;
        let genders = ''; // 男女，外包人员前加头像
        // 2、结合素材文件，渲染地图上元素
        let svgContent = <g key={element.mapElementId} />;
        svgContent = (
            <svg width={element?.customElementWidth || 0} height={element?.customElementHeight || 0}>
                <g dangerouslySetInnerHTML={{ __html: element?.customElement }} />
            </svg>
        );
        // 3、渲染元素上需要显示的文字以及计算文字的旋转角度，需要保持文字正向显示
        let contentText = element?.objectName || '';
        let defaultTooltipKeyName = '';
        let tooltipObj = '';
        let contentSvg = '';
        let offset = [
            Number(element?.customElementWidth) / 2 || 0,
            Number(element?.customElementHeight) / 2 || 0,
        ];
        let center = [
            Number(element?.customElementWidth) / 2,
            Number(element?.customElementHeight) / 2,
        ];
        let groupRotate = Number(element?.cycleValue) % 360;
        if (groupRotate < 0) {
            groupRotate += 360;
        }
        let rotate = 0;
        if ((groupRotate >= 0 && groupRotate < 90) || (groupRotate >= 270 && groupRotate <= 360)) {
            rotate = 0;
        } else if (groupRotate >= 90 && groupRotate < 270) {
            rotate = 180;
        }
        // 4、修改元素的透明度
        let opacity = 1;
        // 5、渲染元素的颜色，如果对应的素材不支持修改颜色，则替换对应状态的素材
        let fill = COLOR_DEFAULT;

        // 20210616 新增设置素材状态颜色和透明度，objectColor如果不为空，并且以#开头，则为设置的素材颜色；不为空并且不已#开头，根据objectColor的内容去查找素材状态颜色；否则为默认颜色
        if (element?.objectColor) {
            if (element?.objectColor.startsWith('#')) {
                fill = element?.objectColor;
            } else if (element?.objectColor === 'free') {
                opacity = mapColorSet?.freeTransparent || 1;
                fill = mapColorSet?.freeRgb || '#69E5A5';
            } else if (element?.objectColor === 'busy') {
                opacity = mapColorSet?.busyTransparent || 1;
                fill = mapColorSet?.busyRgb || '#FD7C7C';
            } else if (element?.objectColor === 'disabled') {
                opacity = mapColorSet?.disabledTransparent || 1;
                fill = mapColorSet?.disabledRgb || '#D1D8DF';
            } else if (element?.objectColor === 'onHold') {
                opacity = mapColorSet?.onHoldTransparent || 1;
                fill = mapColorSet?.onHoldRgb || '#1110EF';
            } else if (element?.objectColor === 'unreserved') {
                opacity = mapColorSet?.unreservedTransparent || 1;
                fill = mapColorSet?.unreservedRgb || '#FFB26A';
            }
        }

        const customStyle = elementsColor.length > 0;
        // 如果组件没有传进样式，按默认显示，如果有传参数，按参数修改
        if (!showStateIds && !customStyle) {
            if (selectedEle.some((item) => item.mapElementId === element?.mapElementId)) {
                fill = COLOR_SELECTED;
            }
            if (element?.svgStateElement) {
                svgContent = (
                    <svg width={element?.customElementWidth || 0} height={element?.customElementHeight || 0}>
                        <g dangerouslySetInnerHTML={{ __html: element?.customElement }} />
                    </svg>
                );
            }
        } else {
            // 如果组件外部传入主动变更状态的集合，则替换响应的状态元素
            let stateObj = showStateIds.find((o) => String(o.id) === String(element?.mapElementId)) || {};
            // 通过elementsColor传入的颜色优先级高
            if (customStyle) {
                const tmpCustomStyle =
                    elementsColor.find((o) => String(o.id) === String(element?.mapElementId)) || {};
                stateObj = { ...stateObj, ...tmpCustomStyle };
            }

            if (stateObj) {
                contentText = stateObj?.text || '';
                // 如果设置了颜色按相应颜色显示
                if (stateObj.color) {
                    if (stateObj.color.startsWith('#')) {
                        fill = stateObj.color;
                    } else if (stateObj.color === 'free') {
                        opacity = mapColorSet?.freeTransparent || 1;
                        fill = mapColorSet?.freeRgb || '#69E5A5';
                    } else if (stateObj.color === 'busy') {
                        opacity = mapColorSet?.busyTransparent || 1;
                        fill = mapColorSet?.busyRgb || '#FD7C7C';
                    } else if (stateObj.color === 'disabled') {
                        opacity = mapColorSet?.disabledTransparent || 1;
                        fill = mapColorSet?.disabledRgb || '#D1D8DF';
                    } else if (stateObj?.color === 'onHold') {
                        opacity = mapColorSet?.onHoldTransparent || 1;
                        fill = mapColorSet?.onHoldRgb || '#1110EF';
                    } else if (stateObj?.color === 'unreserved') {
                        opacity = mapColorSet?.unreservedTransparent || 1;
                        fill = mapColorSet?.unreservedRgb || '#FFB26A';
                    }
                }
                // console.log('customStyle stateObj', fill, stateObj)
                if (!_.isEmpty(stateObj.contentObj)) {
                    if (isGenders && stateObj.contentObj.userName) {
                        if (Number(stateObj.genders) === 1) {
                            genders = '👨';
                        } else if (Number(stateObj.genders) === 2) {
                            genders = '👩';
                        } else if (Number(stateObj.genders) === 3) {
                            genders = '‍👨‍💻';
                        }
                    }
                    tooltipObj = stateObj.contentObj;
                    defaultTooltipKeyName = tooltipObj[defaultTooltipKey];
                }
            }
        }
        // 7、添加被搜索元素的标记
        let markIcon = '',
            markOnlyId = '';
        if (typeof markId === 'object' && Array.isArray(markId)) {
            if (markId?.includes(element.mapElementId)) {
                markOnlyId = element.mapElementId;
            }
        } else if (markId === String(element.mapElementId)) {
            markOnlyId = markId;
        }

        if (markOnlyId && String(markOnlyId) === String(element?.mapElementId)) {
            const param = {
                rotate: Number(element?.cycleValue) || 0,
                width: Number(element?.customElementWidth) || 0,
                height: Number(element?.customElementHeight) || 0,
            };

            if (locationSvgMark && locationSvgMark.element) {
                let svgWidth = '';
                let svgHeight = '';
                if (locationSvgMark.viewBox) {
                    const viewSize = locationSvgMark.viewBox.split(' ') || [];
                    svgWidth = (viewSize?.length === 4 && viewSize[2]) || '';
                    svgHeight = (viewSize?.length === 4 && viewSize[3]) || '';
                }
                const objParam = Object.assign({}, { ...param }, { svgWidth, svgHeight });

                //  window.console.log('markStateId', objParam, element?.mapElementId);
                markIcon = (
                    <MarkIcon
                        {...objParam}
                        svgPath={() => {
                            return (
                                <g
                                    dangerouslySetInnerHTML={{
                                        __html: locationSvgMark.element,
                                    }}
                                />
                            );
                        }}
                    />
                );
            }

            if (markSvg) {
                markIcon = <MarkIcon {...param} svgPath={markSvg} />;
            }

            if (!locationSvgMark?.element && !markSvg) {
                markIcon = <MarkIcon {...param} />;
            }
        }

        // 8、添加被选中元素的标记
        let selectedIcon = '',
            selectedId = '',
            selectedKey = '';
        selectedEle.forEach((s, index) => {
            if (s.mapElementId === element?.mapElementId) {
                selectedId = s.mapElementId;
                selectedKey = (Number(index) + 1).toString();
            }
        });

        if (selectedId && String(selectedId) === String(element?.mapElementId)) {
            const param = {
                rotate: Number(element?.cycleValue) || 0,
                width: Number(element?.customElementWidth) || 0,
                height: Number(element?.customElementHeight) || 0,
                text: selectedKey,
                multiple,
            };
            selectedIcon = <SelectedIcon {...param} svgPath={selectedSvg} />;
        }

        // 9、添加根据状态标记元素的标记
        let markStateIcon = '';
        if (markStateId && markStateId.length > 0) {
            markStateId.forEach((m) => {
                if (String(m) === String(element?.mapElementId)) {
                    const param = {
                        rotate: Number(element?.cycleValue) || 0,
                        width: Number(element?.customElementWidth) || 0,
                        height: Number(element?.customElementHeight) || 0,
                    };
                    markStateIcon = <MarkIcon {...param} svgPath={markStateSvg} />;
                }
            });
        }

        // console.log('renderElements',  element?.svgTypeCode, visible)
        // 渲染
        let textRole = 0;
        if (element?.cycleValue) {
            textRole = 0 - Number(element?.cycleValue);
        }

        // hideNameType 是否有不显示内容的素材类型
        let hideName = false;
        if (hideNameType?.length > 0) {
            if (hideNameType.indexOf(element?.svgTypeCode) !== -1) {
                hideName = true;
            }
        }

        const { fontColor } = baseMap;
        let textShowColor = fontColor || '#fff';
        if (element?.elementFontColor) {
            textShowColor = element?.elementFontColor;
        }
        if (textColor) {
            textShowColor = textColor;
        }

        const tipObjName = {
            contentSvg: contentSvg,
            name: Array.isArray(contentText) ? contentText[0] : contentText,
            width: Number(element?.customElementWidth) / 2 || 0,
            height: Number(element?.customElementHeight) / 2 || 0,
            x: Number(element?.stationx) || 0,
            y: Number(element?.stationy) || 0,
        };

        // 是否使用tooltip显示名称
        const bNameVisible =
            isTextToolTip &&
            ((textToolTipList?.length > 0 && textToolTipList.some((v) => v === element?.mapElementId)) ||
                textToolTipList?.length === 0);

        // 检查color并进行处理,兼容透明度,后端svg下载pdf方法不支持rgba
        const { rgbHex, alphaDecimal} = parseColorWithAlpha(fill);
        fill = rgbHex || fill;
        opacity = alphaDecimal || opacity;

        return (
            <g
                key={element?.mapElementId}
                strokeWidth="1"
                fill={fill}
                fillOpacity={opacity}
                transform={`
          translate(${element?.stationx || 0}, ${element?.stationy || 0})
          scale(1, 1)
          rotate(
              ${element?.cycleValue || 0},
              ${(Number(element?.customElementWidth) || 0) / 2},
              ${(Number(element?.customElementHeight) || 0) / 2}
          )
        `}
                onMouseEnter={() => {
                    // 鼠标移动到元素上，显示气泡框
                    if (typeof tooltipContent === 'function') {
                        contentSvg = tooltipContent(tooltipObj);
                    }
                    setTipObj({
                        contentSvg: contentSvg,
                        name: defaultTooltipKeyName,
                        width: Number(element?.customElementWidth) || 0,
                        height: Number(element?.customElementHeight) || 0,
                        x: Number(element?.stationx) || 0,
                        y: Number(element?.stationy) || 0,
                    });
                    setShowTip(true);
                }}
                onMouseLeave={() => {
                    // 鼠标从元素上移开，关闭气泡框
                    setShowTip(false);
                }}
                onTouchStart={(e) => {
                    // 触屏端触发
                    e.stopPropagation();
                    // 判断默认行为是否可以被禁用
                    if (e.cancelable) {
                        // 判断默认行为是否已经被禁用
                        if (!e.defaultPrevented) {
                            e.preventDefault();
                        }
                    }
                    if (typeof tooltipContent === 'function') {
                        contentSvg = tooltipContent(tooltipObj);
                    }
                    setTipObj({
                        contentSvg: contentSvg,
                        name: defaultTooltipKeyName,
                        width: Number(element?.customElementWidth) || 0,
                        height: Number(element?.customElementHeight) || 0,
                        x: Number(element?.stationx) || 0,
                        y: Number(element?.stationy) || 0,
                    });
                    setShowTip(true);
                }}
                onClick={() => {
                    onClickHandle(element, true);
                }}
            >
                {svgContent}
                {!noName && !hideName && contentText && (
                    Array.isArray(contentText) ? (
                        // 多行显示：当contentText是数组时，垂直居中
                        <g transform={`rotate(${textRole}, ${center[0]}, ${center[1]})`}>
                            {contentText?.map((textLine, index) => {
                                const fontSize = element?.elementFontSize || 12;
                                const lineHeight = fontSize * 1.2;
                                const totalHeight = contentText.length * lineHeight;
                                // 修正垂直居中计算：从中心点开始，第一行文字基线在中心点上方
                                const startY = offset[1] - totalHeight / 2 + fontSize * 0.8;

                                return (
                                    <SvgTextEllipsis
                                        key={index}
                                        dx={offset[0]}
                                        dy={startY + index * lineHeight}
                                        fill={textShowColor}
                                        fillOpacity={1}
                                        fontFamily="ArialMT"
                                        textAnchor="middle"
                                        fontSize={fontSize}
                                        width={Number(element?.customElementHeight) || 0}
                                    >
                                        {index === 0 ? genders + textLine : textLine}
                                    </SvgTextEllipsis>
                                );
                            })}
                        </g>
                    ) : (
                        // 单行显示：当contentText是字符串时
                        <SvgTextEllipsis
                            transform={`rotate(${textRole}, ${center[0]}, ${center[1]})`}
                            dx={offset[0]}
                            dy={offset[1]}
                            fill={textShowColor}
                            fillOpacity={1}
                            fontFamily="ArialMT"
                            textAnchor="middle"
                            fontSize={element?.elementFontSize || 12}
                            width={Number(element?.customElementHeight) || 0}
                        >
                            {genders + contentText}
                        </SvgTextEllipsis>
                    )
                )}
                {markStateIcon}
                {bNameVisible && (
                    <ToolTipName
                        showTip
                        tipObj={tipObjName}
                        zoom={zoom}
                        textToolTipRender={
                            textToolTipRender
                                ? () => {
                                    return textToolTipRender(tipObjName, element);
                                }
                                : undefined
                        }
                    />
                )}
                {markIcon}
                {selectedIcon}
            </g>
        );
    });

    const baseMapUrl = baseMap?.[mapKey?.url];

    const renderMapEle = useMemo(()=>{
        return mapElementsOnMap && mapElementsOnMap?.map((ele) => renderElements(ele));
    }, [mapElementsOnMap, selectedEleState, baseMap, allElements, locationSvgMark, mapColorSet, markId, markStateId, showStateIds, elementsColor, isGenders, isNotAllowedEle, clickableElement, noName, hideNameType, isTextToolTip, textToolTipList, elementRenderHandle, elementRenderTextAfterHandle, textColor, isShowSvgDefaultColor]);

    const onChangeSvg = useMemoizedFn((value) => {
        // 优化：只在zoom值实际变化时更新状态
        if (zoom !== value.a || !_.isEqual(svgValue, value)) {
            setZoom(value.a);
            // 中心点需要在当前宽高上乘以X 轴缩放值，即value.a，再除以2
            const centerX = value.SVGWidth / 2 * value.a;
            const centerY = value.SVGHeight / 2 * value.a;

            // 计算 effectivePanBoundary
            // - undefined:原有限制方式（bufferX = centerX/2，即 panBoundary = 2）
            // - 'auto': 自动计算，保留 1/10 在可视窗口外
            // - false: 不限制边界
            // - 具体数值: 使用该数值
            let effectivePanBoundary;
            if (panBoundary === 'auto') {
                // 自动计算：panBoundary = 10 * SVGWidth / (SVGWidth - viewerWidth)
                // 当 SVGWidth <= viewerWidth 时，设为 false（不限制）
                if (value.SVGWidth > value.viewerWidth) {
                    effectivePanBoundary = 10 * value.SVGWidth / (value.SVGWidth - value.viewerWidth);
                } else {
                    effectivePanBoundary = false;
                }
            } else {
                effectivePanBoundary = panBoundary;
            }

            // centerX、centerY是中心点， value中的e是X 轴平移，f 是Y 轴平移, viewerWidth是视图宽度，viewerHeight是视图高度，SVGWidth是地图宽度，SVGHeight是地图高度
            // 移动时，e的取值范围是：e > -centerX，且 e < SVGWidth-centerX, f的取值范围是：f > -centerY，且 f < SVGHeight-centerY
            const result = clampPanTranslation(value, centerX, centerY, effectivePanBoundary);
            setSvgValue({...value, ...result});
         //   window.console.log(value, 'mergedScaleFactor-onChangeSvg-333333')
        }
    });

    return (
        <div
            key={key}
            onMouseDown={(e) => {
                e.stopPropagation();
                e.preventDefault();

                if (selectMode && selectableType) {
                    setIsClick(true);
                }
            }}
            onMouseUp={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setIsClick(false);
                if (selectMode && selectableType) {
                    setSelectElements();
                    setSelectMode(false);
                    setSelectedCenter({ x: null, y: null });
                }
            }}
        >
            {!touchZoom && (
                <div
                    style={{
                        position: 'absolute',
                        zIndex: 1,
                        width: componentWidth || DEFAULT_WIDTH,
                        height: componentHeight || DEFAULT_HEIGHT,
                    }}
                />
            )}
            <ReactSVGPanZoom
                key={mapId}
                width={componentWidth || DEFAULT_WIDTH}
                height={componentHeight || DEFAULT_HEIGHT}
                background={background || DEFAULT_BACKGROUND}
                SVGBackground={SVGBackground || DEFAULT_SVGBACKGROUND}
                detectAutoPan={false} //
                detectWheel={svgZoom} // 是否滚轮控制缩放
                detectPinchGesture={svgZoom} // 手指手势是否控制缩放
                tool={svgMove ? tool : TOOL_NONE} // none pan zoom-in, zoom-out, auto
                //  onChangeTool={this.changeTool}
                scaleFactor={ZOOM_FACTOR}
                toolbarProps={{ position: POSITION_NONE }}
                miniatureProps={{ position: POSITION_NONE }}
                ref={Viewer}
                value={svgValue}
                onChangeValue={(value) => onChangeSvg(value)}
                disableDoubleClickZoomWithToolAuto
                // onDoubleClick={() => svgZoom && svgMove && this.doubleClickHandle()}
                onTouchStart={(e) => {
                    onTouchStart(e);
                }}
                onTouchEnd={(e) => {
                    if (isTouchDevice && HAVE_TOUCH_EVENT) {
                        e.stopPropagation();
                        // 判断默认行为是否可以被禁用
                        if (e.cancelable) {
                            // 判断默认行为是否已经被禁用
                            if (!e.defaultPrevented) {
                                e.preventDefault();
                            }
                        }
                        if (selectMode && selectableType) {
                            setSelectElements();
                            setSelectMode(false);
                            setSelectedCenter({ x: null, y: null });
                        }
                    }
                }}
                SVGStyle={SVGStyle}
                style={style}
                onMouseDown={(e) => {
                    e.originalEvent.stopPropagation();
                    e.originalEvent.preventDefault();

                    if (selectMode && selectableType) {
                        setSelectedCenter({ x: e.x, y: e.y });
                    }
                }}
                onMouseUp={(e) => {
                    e.originalEvent.stopPropagation();
                    e.originalEvent.preventDefault();

                    if (selectMode && selectableType) {
                        setSelectElements();
                        setSelectMode(false);
                        setSelectedCenter({ x: null, y: null });
                    }
                }}
                onMouseMove={(e) => {
                    e.originalEvent.stopPropagation();
                    e.originalEvent.preventDefault();

                    if (selectMode && selectableType && isClick) {
                        window.console.log('onMouseMove', e.x, e.y);
                        // 外部点击
                        setIsClick(false);
                        setSelectedCenter({ x: e.x, y: e.y });
                    }

                    if (
                        selectMode &&
                        selectableType &&
                        _.isNumber(selectedCenterState?.x) &&
                        _.isNumber(selectedCenterState?.y)
                    ) {
                        window.console.log('onMouseMove', e.x, e.y);
                        setSelectedArea({ dragX: e.x, dragY: e.y });
                    }
                }}
                scaleFactorMax={mergedScaleFactor.scaleFactorMax}
                scaleFactorMin={mergedScaleFactor.scaleFactorMin}
            >
                <svg width={mapAllSize?.mapWidth} height={mapAllSize?.mapHeight}>
                    {AppendSvg && <AppendSvg width={mapAllSize?.mapWidth} height={mapAllSize?.mapHeight} />}
                    {!baseMap?.baseMapElement && baseMapUrl && (
                        <image
                            xlinkHref={baseMapUrl}
                            width={mapAllSize?.mapWidth}
                            height={mapAllSize?.mapHeight}
                        />
                    )}
                    {baseMap?.baseMapElement && (
                        <g
                            dangerouslySetInnerHTML={{ __html: baseMap?.baseMapElement }}
                            width={mapAllSize?.mapWidth}
                            height={mapAllSize?.mapHeight}
                        />
                    )}
                    {!pathLevelUp && path && <g>
                        <path
                            id={guideThirdSvg ? "path2" : "path1"}
                            d={path}
                            style={Object.assign({}, PATH_STYLE, showPathStyle)}
                            radius="5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        {guideFirstSvg && guideFirstSvg()}
                        {guideThirdSvg && guideThirdSvg()}
                    </g>}
                    {!pathLevelUp && path2 && <g>
                        <path
                            id={"path3"}
                            d={path2}
                            style={Object.assign({}, PATH_STYLE_EX, showPathStyle2)}
                            radius="5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        {guideFirstSvgEx && guideFirstSvgEx()}
                    </g>}
                    <g transform={`translate(${mapAllSize?.extraWidth / 2}, ${mapAllSize?.extraHeight / 2})`}>
                        {renderMapEle}
                    </g>
                    {pathLevelUp && path && <g>
                        <path
                            id={guideThirdSvg ? "path2" : "path1"}
                            d={path}
                            style={Object.assign({}, PATH_STYLE, showPathStyle)}
                            radius="5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        {guideFirstSvg && guideFirstSvg()}
                        {guideThirdSvg && guideThirdSvg()}
                    </g>}
                    {pathLevelUp && path2 && <g>
                        <path
                            id={"path3"}
                            d={path2}
                            style={Object.assign({}, PATH_STYLE_EX, showPathStyle2)}
                            radius="5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        {guideFirstSvgEx && guideFirstSvgEx()}
                    </g>}
                    {/* 导引线图标缩放，跟随整体放大缩小，不需要用自己缩放 */}
                    {start && path && (
                        <StartPosition {...start} zoom={1} svgPath={pathStartSvg} />
                    )}
                    {end && path && (
                        <EndPosition {...end} zoom={1} svgPath={pathEndSvg} />
                    )}
                    {/* 导引线图标缩放，跟随整体放大缩小，不需要用自己缩放 */}
                    {start2 && path2 && pathStartSvg && (
                        <StartPosition {...start2} zoom={1} svgPath={pathStartSvg} />
                    )}
                    {end2 && path2 && pathEndSvg && (
                        <EndPosition {...end2} zoom={1} svgPath={pathEndSvg} />
                    )}
                    {baseMap?.areaAge && isShowArea && (
                        <g transform="translate(1, 1)" width="140" height="40">
                            <rect dx="0" dy="0" width="140" height="40" fill="#eeeeee" />
                            <text
                                fill="#000000"
                                width="140"
                                height="40"
                                dx="70"
                                dy="20"
                                fontSize="14"
                                textAnchor="middle"
                                dominantBaseline="middle"
                            >
                                {`地图面积为: ${baseMap?.areaAge}m²`}
                            </text>
                        </g>
                    )}
                    {selectMode && selectableType && (
                        <g cursor="crosshair">
                            <rect width={mapAllSize?.mapWidth} height={mapAllSize?.mapHeight} fillOpacity="0" />
                            <rect
                                width={selectedAreaState?.dragWidth}
                                height={selectedAreaState?.dragHeight}
                                transform={`translate(${selectedAreaState?.x},${selectedAreaState?.y})`}
                                fill="#e1f1fc"
                                fillOpacity="0.5"
                                stroke="#8bc9f3"
                                strokeWidth="1"
                                strokeDasharray="1,1"
                            />
                        </g>
                    )}
                    {/* 导出PDF时增加图例 */}
                    {mapId &&
                        legendRender &&
                        legendRender(legendList, mapAllSize?.mapHeight, mapAllSize?.mapWidth)}
                    {/* 气泡不缩放，不会跟随整体放大缩小 */}
                    <ToolTip showTip={showTip} tipObj={tipObj} zoom={zoom} />
                    {path && guideSecondSvg && guideSecondSvg()}
                </svg>
            </ReactSVGPanZoom>
        </div>
    );
});

WaferMap.propTypes = {
    mapId: PropsTypes.string.isRequired, // 地图id
    componentWidth: PropsTypes.number, // 组件宽度
    componentHeight: PropsTypes.number, // 组件高度
    background: PropsTypes.string, // 组件背景颜色
    SVGBackground: PropsTypes.string, // svg背景颜色
    SVGStyle: PropsTypes.object, // svg背景颜色
    style: PropsTypes.string, // svg背景颜色
    visibleElement: PropsTypes.array, // 可显示的元素id集合
    visibleType: PropsTypes.array, // 可显示的元素类型集合
    visibleState: PropsTypes.array, // 可显示的元素状态集合
    clickableElement: PropsTypes.array, // 可点击的元素id集合
    clickableType: PropsTypes.array, // 可点击的元素类型集合
    clickableState: PropsTypes.array, // 可点击的元素状态集合
    onClick: PropsTypes.func, // 单选回调方法
    onSelect: PropsTypes.func, // 多选回调方法
    onClickError: PropsTypes.func, // 不可点击事件回调
    mapZoom: PropsTypes.bool, // 控制地图缩放
    mapMove: PropsTypes.bool, // 控制地图移动
    multiple: PropsTypes.bool, // 多选状态
    noName: PropsTypes.bool, // 不显示元素上名称
    showPath: PropsTypes.bool, // 是否显示导引线
    markId: PropsTypes.oneOfType([PropsTypes.string, PropsTypes.arrayOf(PropsTypes.string)]), // 被查询或标记的元素id
    showStateIds: PropsTypes.array, // 显示不同元素的不同状态，数据结构：[{id: 1, state: 'XX', color: '#fff', text: ''}, {}]
    reloadMap: PropsTypes.bool, // 重新加载地图
    reloadFinish: PropsTypes.func, // 重新加载地图完成回调
    touchable: PropsTypes.bool, // 可触摸控制
    deleteId: PropsTypes.string, // 删除已选的元素id
    selectedIds: PropsTypes.array, // 选中元素 ID 集合
    deleteFinish: PropsTypes.func, // 删除已选元素后的回调
    tooltipContent: PropsTypes.func, //鼠标悬浮在素材上的小气泡内容和样式
    elementsColor: PropsTypes.array, // 按照元素id设置颜色,数据结构：[{id: 1, color: '#fff'}, {}]
    pathStartSvg: PropsTypes.func, // 导引线起点 svg 图标函数
    pathEndSvg: PropsTypes.func, //导引线 终点 svg 图标函数
    pathStyle: PropsTypes.object, // 导引线样式
    pathExStyle: PropsTypes.object, // 同楼层第二条导引线样式
    markSvg: PropsTypes.func, // 搜索定位标记 svg 图标函数
    selectedSvg: PropsTypes.func, // 选中标记 svg 图标函数
    defaultTooltipKey: PropsTypes.string, // 气泡里面 可以自定义默认显示取的key
    getSvgDom: PropsTypes.func, // 获取svg的ViewerDOM
    signatureKey: PropsTypes.string, // 签名key
    restfulSignature: PropsTypes.bool, // 控制是否签名
    selectMode: PropsTypes.bool, // 控制是否可拖拽
    setSelectMode: PropsTypes.func, // 重置拖拽多选状态
    selectableType: PropsTypes.string, // 批量操作类型
    selectedEle: PropsTypes.array, // 选中的元素集合回显用
    setSelectedEleFinish: PropsTypes.func, // 回显选中的元素集合后的回显，此时需要程序控制置空选中元素集合
    textColor: PropsTypes.string, // 元素上文字颜色
    fitWidthOrHeight: PropsTypes.string, // 按高度还是宽度适配
    scaleFactorMax: PropsTypes.number, // 地图最大缩放倍数
    scaleFactorMin: PropsTypes.number, // 地图最小缩放倍数
    mapSpaceJump: PropsTypes.bool, // 是否打开区域跳转开关
    reSetMapId: PropsTypes.string, // 绑定区域的素材对应区域的mapId
    requestPrefix: PropsTypes.string, // 请求 URL 前缀
    legendList: PropsTypes.array, //导出PDF时增加图例
    legendRender: PropsTypes.func, //图例渲染函数
    isGenders: PropsTypes.bool, // 是否在素材人名前显示男 女 外包类型头像
    onElementsLoad: PropsTypes.func, // 素材获取完成回调
    zoomRate: PropsTypes.number, // 地图适配放大倍数
    defaultPath: PropsTypes.string, // 默认路径前缀
    markStateId: PropsTypes.array, // 标记元素状态id
    markStateSvg: PropsTypes.func, //  标记元素状态 svg 图标函数
    isTouchDevice: PropsTypes.bool, // 是否是一体机设备
    centerEleRate: PropsTypes.number, // 设置中心素材放大倍数
    centerElement: PropsTypes.object, // 设置中心素材
    clickToCenter: PropsTypes.bool, // 点击素材剧中放大
    hideNameType: PropsTypes.array, // 隐藏显示内容的素材类型
    AppendSvg: PropsTypes.object, // 追加显示的svg，主要用于显示地图区域
    mapExtraProps: PropsTypes.object, // 额外需要处理的属性，目前可以在地图的宽高上追加宽高
    pathLineKey: PropsTypes.object, // 导引线显示的字段
    mapKey: PropsTypes.object, // 地图显示的字段
    windowsTouchSupport: PropsTypes.bool, // 是否是 windows 触摸屏
    elementRenderHandle: PropsTypes.func, // 元素渲染时自定义处理（在文字前）
    elementRenderTextAfterHandle: PropsTypes.func, // 元素渲染时自定义处理（在文字后）
    isTextToolTip: PropsTypes.bool, // 元素文字是否使用tooltip显示
    textToolTipList: PropsTypes.array, // 元素文字tooltip显示list
    textToolTipRender: PropsTypes.func, // 元素文字tooltip部分整个渲染方法
    mapDataSource: PropsTypes.bool, //地图上元素来源，false为组件内部获取，true时为外部传入
    mapElementsList: PropsTypes.array, // 地图上元素集合， 当mapDataSource为true时，mapElementsList不能为空
    isShowSvgDefaultColor: PropsTypes.bool, //是否显示地图上未绑定素材默认颜色
    appGetPathByUrl: PropsTypes.bool, //移动端是否从接口返回path信息
    lang: PropsTypes.string, // 语言, "cn"中文、"en"英文、"tw"繁体
    isDoubleMap: PropsTypes.bool, // 是否是多地图
    isStartGuide: PropsTypes.bool, // 是否开始导航
    guideFirstSvg: PropsTypes.func, // 导航第一段 svg 图标函数
    guideSecondSvg: PropsTypes.func, //导航第二段  svg 图标函数
    guideThirdSvg: PropsTypes.func, //导航第三段  svg 图标函数
    guideFirstSvgEx: PropsTypes.func, // 当前楼层, 第二条导航
    refreshGuide: PropsTypes.number, // 是否重新导航
    handleGetPathInfo: PropsTypes.func, // 路劲回调方法
    customBaseMap: PropsTypes.object,
    pathLevelUp: PropsTypes.bool, // 导航层级是否置顶
    panBoundary: PropsTypes.oneOfType([PropsTypes.number, PropsTypes.bool, PropsTypes.string]), // 平移边界限制参数
    // false: 不限制边界
    // undefined (默认):保持原有限制方式 (bufferX = centerX/2)
    // 'auto': 自动根据比例计算，保留 1/10 在可视窗口外
    // 具体数值: 使用 centerX/panBoundary 作为边界缓冲值
    // 示例: <WaferMap panBoundary={false} /> 不限制
    // 示例: <WaferMap panBoundary="auto" /> 自动计算
    // 示例: <WaferMap panBoundary={10} /> 自定义值
};

WaferMap.defaultProps = {
    componentWidth: DEFAULT_WIDTH,
    componentHeight: DEFAULT_HEIGHT,
    background: DEFAULT_BACKGROUND,
    SVGBackground: DEFAULT_SVGBACKGROUND,
    visibleElement: undefined,
    visibleType: undefined,
    visibleState: undefined,
    clickableElement: undefined,
    clickableType: undefined,
    clickableState: undefined,
    onClick: () => {},
    onSelect: () => {},
    onClickError: () => {},
    mapZoom: true,
    mapMove: true,
    multiple: false,
    noName: false,
    showPath: false,
    markId: '',
    showStateIds: [],
    elementsColor: [],
    reloadMap: false,
    reloadFinish: () => {},
    touchable: true,
    deleteId: '',
    selectedIds: [],
    deleteFinish: () => {},
    tooltipContent: () => {},
    pathStartSvg: undefined,
    pathEndSvg: undefined,
    pathStyle: {},
    markSvg: undefined,
    selectedSvg: undefined,
    defaultTooltipKey: '',
    getSvgDom: () => {},
    signatureKey: null,
    restfulSignature: false,
    style: {}, // svg背景颜色
    SVGStyle: {}, // svg背景颜色
    selectMode: false, //是否可拖拽
    setSelectMode: () => {},
    selectableType: '', //批量操作类型
    selectedEle: [],
    setSelectedEleFinish: () => {},
    textColor: '', // 元素上文字颜色
    fitWidthOrHeight: '',
    scaleFactorMax: undefined,
    scaleFactorMin: undefined,
    mapSpaceJump: false,
    reSetMapId: () => {},
    requestPrefix: '',
    legendList: [], //图例数据格式[{color:   , text:   }]
    legendRender: undefined, //图例渲染函数
    isGenders: false, // 是否在素材人名前显示男 女 外包类型头像
    onElementsLoad: () => {},
    zoomRate: 1, // 地图适配放大倍数
    defaultPath: 'vsk/', // 默认路径前缀
    markStateId: [],
    markStateSvg: undefined,
    isTouchDevice: false,
    centerEleRate: 1, // 设置中心素材放大倍数
    centerElement: {}, // 设置中心素材
    clickToCenter: false, // 点击素材剧中放大
    hideNameType: [],
    pathLineKey: { start: 'lineStart', end: 'lineEnd', mid: 'lineMid' },
    mapKey: { url: 'baseMapUrl' },
    windowsTouchSupport: false, // 是否是 windows 触摸屏
    elementRenderHandle: undefined, // 元素渲染时自定义处理（文字前）
    elementRenderTextAfterHandle: undefined, // 元素渲染时自定义处理（文字后）
    isTextToolTip: false, // 元素文字是否使用tooltip显示
    textToolTipList: [], // 元素文字tooltip显示list
    textToolTipRender: undefined,
    mapDataSource: false, //地图上元素来源，false为组件内部获取，true时为外部传入
    mapElementsList: [], // 地图上元素集合， 当mapDataSource为true时，mapElementsList不能为空
    isShowSvgDefaultColor: false, //是否显示地图上未绑定素材默认颜色
    appGetPathByUrl: false, //移动端是否从接口返回path信息
    lang: 'cn', //地图元素接口需要传入语言，实现会议室支持国际化显示
    isNotAllowedEle: false,
    isDoubleMap: false, // 是否是多地图
    isStartGuide: false, // 是否开始导航
    guideFirstSvg: undefined, // 导航第一段 svg 图标函数，当前楼层
    guideSecondSvg: undefined, //导航第二段  svg 图标函数, 按设计来看是位于下方的地图上显示，需要使用时判断上楼还是下楼，修改路径起止点
    guideThirdSvg: undefined, //导航第三段  svg 图标函数，目标楼层
    guideFirstSvgEx: undefined, // 当前楼层, 第二条导航
    refreshGuide: -1, // 是否重新导航
    customBaseMap: null, // 是否使用外部地图基础数据
    handleGetPathInfo: () => {}, // 路劲回调方法
    pathLevelUp: false, // 导航层级是否置顶
    pathExStyle: {},
    panBoundary: undefined, // 平移边界限制参数，false时不限制边界，undefined时保持原有限制方式(2)，'auto'时自动根据比例计算(保留1/10在可视窗口外)，具体数值时使用centerX/panBoundary作为边界缓冲值
};

export default WaferMap;
